const employees = {
  headerButtons: {
    create: {
      createBtn: 'Crear',
    },
  },

  edit: {
    tabs: {
      information: 'Información',
      history: 'Historia',
      bookingHistory: 'Historial de reservas',
    }
  },

  table: {
    headers: {
      createBtn: 'Crear',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
      homeAddress: 'Dirección de domicilio',
      workAddress: 'Dirección de trabajo',
      createdAt: 'Creado en',
      createdBy: 'Creado por',
    },
  },
  form: {
    header: {
      create: {
        title: 'Crear',
      },

      update: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Acciones',
      buttons: {
        resetPassword: 'Restablecer contraseña',
      },
    },

    sections: {
      profiles: {
        header: 'Perfiles',
        fields: {
          profiles: {
            label: 'Perfiles',
          },
          attributes: {
            label: 'Atributos'
          }
        },
      },
      personalDetails: {
        header: 'Detalles personales',
        fields: {
          firstName: {
            label: 'Nombre',
          },
          lastName: {
            label: 'Apellido',
          },
          email: {
            label: 'Correo electrónico',
          },
          phone: {
            label: 'Telefono',
          },
          additionalPhone: {
            label: 'Teléfono adicional',
          },
        },
      },
      addresses: {
        header: 'Direcciones de los empleados',
        fields: {
          workAddress: {
            label: 'Dirección de trabajo',
          },
          homeAddress: {
            label: 'Dirección de domicilio',
          },
          additionalHomeAddress: {
            label: 'Dirección de inicio 2',
          },
        },
      },
    },
  },

  create: {
    confirmButtonText: 'Enviar',
    toasts: {
      success: 'Empleado creado correctamente',
      error: 'Ocurrió un error al crear el padre',
    },
  },
  update: {
    activeStatus: {
      statusActive: 'Activo',
      statusDeactivate: 'Inactiva',
    },

    suspend: {
      actionActivate: 'Reactivar',
      actionDeactivate: 'Suspender',
      suspendModal: {
        popupTitleDeactivation: 'Suspender pasajero',
        popupTitleActive: 'Suspender Motivo',
        popupTitleUnsuspend: 'Motivo de remover suspensión',
        popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
        popupActionActive: 'Reactivar pasajero',
        popupActionDeactivate: 'Suspender pasajero',
      },
    },
    toasts: {
      success: 'Padre actualizado correctamente',
      error: 'Ocurrió un error al actualizar el padre',
      fetchError: 'Algo salió mal, inténtelo de nuevo.',
    },
  },
};

export default employees;
